export const DEFAULT_ERROR_MESSAGE =
  "Une erreur est survenue, veuillez reéssayer plus tard ou contacter le service client.";
export const EXERCICE_PROCHAIN = "PROCHAIN";
export const EXERCICE_ENCOURS = "EN_COURS";
export const CONFIRMATION_MSG_SOUSCRIPTION_AVEC_Forfait =
  "Attention! Vous avez déjà un forfait valable avec un solde disponible, êtes vous sûr de vouloir acheter un nouveau forfait ? ";

export const CONFIRMATION_MSG_PART1 =
    "Pour une activation instantanée de votre forfait, veuillez procéder au paiement en ligne de votre achat via ";
export const PAIEMENT_ELECTRONIQUE = "Paiement électronique";
export const CONFIRMATION_MSG_PART2 =
    ". Si vous optez par ";
export const AUTRES_MOYENS_DE_PAIEMENT = "Autres moyens de paiement";
export const CONFIRMATION_MSG_PART3 =
    ", votre forfait ne sera validé qu’après l’encaissement effectif de votre virement, soit après ";

export const CONFIRMATION_MSG_PART4 ='24h'

